import moment from 'moment';

export const dateFormatter = (date, frt = 'MM/DD/YYYY')=>{
    if(!date) return null;
    return moment(date).format(frt);
}